// Auto-generated by scripts/generate-registry.mjs from packages/modules/round_gem_vault/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const round_gem_vault: ModuleSchema = {
  "id": "round_gem_vault",
  "uniqueId": "B3D_HB5X4",
  "createdAt": "2026-10-28T07:20:02.790Z",
  "updatedAt": "2026-10-28T14:14:02.483Z",
  "label": "Round Gem Vault",
  "description": "Isolated round jewelry container with a functional raised-thread screw-on lid",
  "category": "storage",
  "tags": [
    "round-gem-vault"
  ],
  "sliders": [
    {
      "key": "bodyDiameter",
      "label": "Body Diameter",
      "min": 58,
      "max": 120,
      "default": 58,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseHeight",
      "label": "Base Height",
      "min": 20,
      "max": 100,
      "default": 30,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "lidHeight",
      "label": "Lid Height",
      "min": 12,
      "max": 60,
      "default": 14,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "nominalDiameter",
      "label": "Thread Diameter",
      "min": 60,
      "max": 70,
      "default": 60,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "threadLength",
      "label": "Thread Length",
      "min": 10,
      "max": 12,
      "default": 10,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "collarWall",
      "label": "Lid Collar Wall",
      "min": 4,
      "max": 10,
      "default": 4,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Threaded Base",
      "default": "#b7791f",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "lid",
      "label": "Threaded Lid",
      "default": "#d69e2e",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "base",
      "label": "Base",
      "name": "Base",
      "color": "#b7791f",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base",
          "label": "Threaded Base",
          "name": "Threaded Base",
          "groupId": 0,
          "colorKey": "base",
          "defaultColor": "#b7791f",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "lid",
      "label": "Lid",
      "name": "Lid",
      "color": "#d69e2e",
      "assembled_z_offset": 0,
      "exploded_z_offset": 18,
      "parts": [
        {
          "id": "lid",
          "label": "Threaded Lid",
          "name": "Threaded Lid",
          "groupId": 1,
          "colorKey": "lid",
          "defaultColor": "#d69e2e",
          "assembled_z_offset": 0,
          "exploded_z_offset": 18,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Base and Lid"
    }
  ]
};
